import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: row-reverse;
	align-items: center;
	gap: var(--gap);
	span {
		cursor: pointer;
	}
	.component-view-pipe {
		color: var(--btn-text-alt--color);
		cursor: default;
	}
`;
